/* ARSHÉ — mobile bottom navigation. Uses existing navigation/drawer behavior. */
(function () {
  'use strict';

  function initArsheBottomNav() {
    var nav = document.querySelector('[data-arshe-mobile-bottom-nav]');
    if (!nav) return;

    var menuTrigger = nav.querySelector('[data-arshe-bottom-menu]');
    var quizTrigger = nav.querySelector('[data-arshe-bottom-quiz]');
    var existingMenuButton = document.querySelector('.arshe-menu-toggle');

    if (quizTrigger) {
      quizTrigger.addEventListener('click', function () {
        /* Use the existing Scent Finder assistant/modal — never the personality section. */
        var scentFinderButton = document.querySelector('[data-arshe-scent-finder] [data-sf-open]');
        if (scentFinderButton) {
          scentFinderButton.click();
        }
      });
    }

    if (menuTrigger && existingMenuButton) {
      menuTrigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        /* The hamburger owns the drawer. Trigger it without any navigation. */
        existingMenuButton.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      });

      var drawer = document.querySelector('[data-arshe-mobile-menu-v2]');
      if (drawer) {
        var syncMenuState = function () {
          var open = drawer.classList.contains('is-open');
          menuTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
          menuTrigger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
          menuTrigger.classList.toggle('is-active', open);
        };
        new MutationObserver(syncMenuState).observe(drawer, { attributes: true, attributeFilter: ['class'] });
        syncMenuState();
      }
    }

    /* Keep the existing cart drawer state authoritative.
       This class is only a coordination hook for the fixed mobile bars. */
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      var syncCartState = function () {
        /* The ARSHÉ cart is a custom <cart-drawer> using `is-open`, not
           Dawn's native `active` class. The old check was immediately
           clearing the cart-open coordination class after the drawer opened,
           which is why the sticky purchase bar and floating scent button
           continued to sit over the cart. */
        var open = cartDrawer.classList.contains('is-open');
        document.documentElement.classList.toggle('arshe-cart-open', open);
        document.body.classList.toggle('arshe-cart-open', open);
      };
      new MutationObserver(syncCartState).observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });
      syncCartState();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initArsheBottomNav);
  else initArsheBottomNav();
})();
